import { render, staticRenderFns } from "./AppConfigIndex.vue?vue&type=template&id=3f5f6330&"
import script from "./AppConfigIndex.vue?vue&type=script&lang=js&"
export * from "./AppConfigIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports